import React, { useEffect, useState, createElement } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useScript } from 'hooks/useScript';
import { components } from './Components';
import Text from 'components/3catinfo/Text';
import __isArray from 'lodash/isArray';
import __isEmpty from 'lodash/isEmpty';
import styles from './cosminutaminut.module.scss';

const CosMinutaminutParsejat = (props) => {
    const { cos, estil } = props;
    const cosParse = JSON.parse(cos);
    const stylesCos = clsx({
        [styles.cos]: true,
        [styles[estil]]: !!estil
    });

    if (__isArray(cosParse) && !__isEmpty(cosParse)) {
        const result = cosParse.map((item, index) => {
            const tipus = item.tipus.toUpperCase();
            return (
                <React.Fragment key={`cos-component-${item.tipus}-${index}`}>
                    {createElement(components[tipus], {
                        ...item.props
                    })}
                </React.Fragment>
            );
        });
        return <div className={stylesCos}>{result}</div>;
    } else {
        return <></>;
    }
};
const CosMinutaminut = (props) => {
    const { cos, estil } = props;
    const router = useRouter();
    const [renderCos, setRenderCos] = useState(<></>);
    const { isJavaScriptClientEnabled } = useScript();
    const stylesCos = clsx({
        [styles.cos]: true,
        [styles[estil]]: !!estil
    });

    const getCos = () => {
        const cosHtml = document.createElement(null);
        cosHtml.innerHTML = cos;
        if (!cosHtml.querySelector('p')) {
            cosHtml.innerHTML = `<p>${cos}</p>`;
        }

        return cosHtml.innerHTML;
    };

    useEffect(() => {
        if (cos && !__isArray(cos)) {
            setRenderCos(<Text className={stylesCos} text={getCos()} />);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath, cos]);

    return isJavaScriptClientEnabled ? (
        <div data-testid='item-minutaminut-cos'>{renderCos}</div>
    ) : (
        <>
            <div dangerouslySetInnerHTML={{ __html: cos }}></div>
        </>
    );
};

const isValidJSON = (str) => {
    try {
        JSON.parse(str);
        return true;
    } catch (error) {
        return false;
    }
};

const Cos = (props) => {
    const { entradeta, estil } = props;
    return isValidJSON(entradeta) ? (
        <CosMinutaminutParsejat cos={entradeta} estil={estil} />
    ) : (
        <CosMinutaminut cos={entradeta} estil={estil} />
    );
};

export default Cos;
